// GÜMÜŞALAN ELEKTRİK — şirket kimliği (PDF şablonları, makbuz, ekstre vb. için ortak)
export const COMPANY = {
  name: "GÜMÜŞALAN ELEKTRİK",
  owner: "HÜSEYİN GÜMÜŞALAN",
  address: "KUMBURGAZ MH. BURGAZ CADDESİ NO:21 B, BÜYÜKÇEKMECE / İSTANBUL",
  email: "gumusalanelektrik@hotmail.com",
  taxOffice: "BÜYÜKÇEKMECE VERGİ DAİRESİ",
  tckn: "48622429120",
  phone: "0542 592 45 90",
  salesRep: "Hüseyin GÜMÜŞALAN",
  logo: "/gumusalan-logo.png",
  tagline: "Elektrik Malzemeleri Toptan & Perakende",
};
